export { SpeechRecognitionButton } from './SpeechRecognitionButton';
